import temporaryMutationQuery from '../../mutations/supplier/QuickPurchaseInvoiceTempMutation.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchaseInvoiceQuick: EntityType = {
  type: 'QuickPurchaseInvoiceHeader',
  title: 'Quick Purchase Invoices',
  formTitle: 'Quick Invoice',
  formUrl: '/Suppliers/QuickInvoice/Form/',
  temporarySave: temporaryMutationQuery,
  permissionLabel: 'Quick Purchase Invoice',
  screenReference: 'SUPPLIER_INVOICES',
};

export default PurchaseInvoiceQuick;
